export function isOverflowing(el) {
  return !!el && el.scrollWidth > el.clientWidth;
}
